import styled, { css } from "styled-components";

//index.jsx
export const AdditionalSubAreaFrame = styled.div`
  display: flex;
  align-items: center; // Center items vertically in the container
  gap: 10px;
  align-self: stretch;
  width: 100%;
  height: auto;
`;
export const AddText = styled.h2`
  color: #000;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Verizon-NHG-eDS";
  font-size: 16px;
  font-style: normal;
  font-weight: ${(props) => (props.boldText ? 700 : 400)};
  line-height: 20px;
  letter-spacing: 0.5px;
  line-height: 1;
  margin: 0;
  vertical-align: middle;
  cursor: pointer;
`;
export const BaseLayoutForRoiModal = styled.div`
  width: 100%;
  max-width: 780px;
  gap: 8px;
  padding: 12px;
  overflow-y: auto;
  position: none;
`;

export const CreateAlertTitle = styled.h1`
  font-family: Verizon NHG DS;
  font-size: 32px;
  font-weight: 700;
  line-height: 36px;
  text-align: left;

  @media only screen and (max-width: 767px) {
    font-size: 24px;
    line-height: 28px;
  }
`;

export const ContentFrame = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 784px;
  overflow-y: auto;
  gap: 24px;
  height: auto;
`;

export const FrameForHeading = styled.div`
  width: 100%;
  max-width: 784px;
  height: auto;
  min-height: 36px;
  gap: var(--space3X);
  padding-bottom: 30px;
`;

export const FrameForHeadingContainer = styled.div`
  display: flex;
  flex-direction: row;
  justifyContent: space-between;
`;
export const FrameForHeadingContainerTitleDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 25px;
  marginBottom: 5px
`;

export const FrameForHeadingContainerToggleDiv = styled.div`
   border-left: 1px solid lightgray;
   height: auto;
   margin-bottom: 30px;
   padding-left: 10px;
   gap: 35px;
`;

export const AlertNameFrameAndTimeFrame = styled.div`
  width: 100%;
  height: auto;
  gap: 8px;
`;

export const ActionsFrame = styled.div`
  max-width: 752px;
  max-height: 500px;
  width: 100%
  height: auto;
  overflow: scroll;
  gap: 8px;

  @media (max-width: 479px) {
    max-height: none;
    overflow: visible;
  }
`;

export const UserGroupsFrame = styled.div`
  width: 100%;
  height: auto;
  gap: 12px;
  max-width: 553px;
  max-height: 192px;
  width: 100%
  height: auto;
  margin-top:-40px;

  @media (max-width: 479px) {
    max-width: 100%;
    max-height: none;
    flex-direction: column;
  }
`;

export const UserHeadingText = styled.h5`
  font-family: Verizon NHG DS;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
  text-align: left;
  margin-top: -20px;
`;
export const TimeFrameText = styled.h5`
  font-family: Verizon NHG DS;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
  text-align: left;
  margin-top: 30px;
`;

export const UserGroupOptions = styled.div`
  max-width: 328px;
  width: 100%;
  height: 200px;
  overflow-y: auto;
  margin-left: 1px;
  margin-top: -10px;
  scrollbar-width: thin !important;
`;

export const UserGroupContainer = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  border: none;
  max-width: 553px;
  width: 100%;
`;

export const AlertPreferences = styled.div`
  width: 165px;
  height: 64px;
  gap: 8px;
  opacity: 0px;
  margin-top: -8px;

  @media (max-width: 479px) {
    width: 100%;
    height: auto;
  }
`;

export const ActionsInsideFrame = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  max-width: 657px;
  height: auto;
  gap: 40px;
  flex-wrap: nowrap;

  @media (max-width: 479px) {
    max-width: 70vw;
  }
`;

export const GrayContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 752px;
  max-height: ${(props) =>
    props.Action ? "300px" : props.trigger ? "244px" : "106px"};
  height: auto;
  padding: 20px;
  gap: ${(props) => (props.trigger ? "12px" : "10px")};
  border-radius: 8px;
  background: var(--gray-95, #f6f6f6);
`;

export const AlertNameInputFrame = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  height: auto;
  min-height: 64px;
  gap: 40px;
`;

export const RoiCancelSubmitFrame = styled.div`
  height: 75px;
  gap: 8px;
  position: sticky;
  bottom: 0;
`;

//styles.jsx

export const CustomTFFrame = styled.div`
  max-width: 700px;
  height: auto;
  width: 100%;
  max-height: 128px;
  gap: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const CustomTFDropdownsFrame = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  max-width: 700px;
  height: auto;
  width: 100%;
  max-height: 64px;

  @media (max-width: 479px) {
    flex-direction: column;
  }
`;

export const CustomTFDaysInWeek = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;
`;

export const FrameForDay = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid #d8dada;
  cursor: pointer;
  ${(props) =>
    props.isSelected &&
    css`
      background: #000000;
      color: #ffffff;
    `}
`;

export const DayOfTheWeekText = styled.div`
  font-family: Verizon NHG DS;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
  text-align: center;
`;

//Trigger.jsx
export const InputHeaderTitle = styled.h5`
  font-family: Verizon NHG DS;
  font-size: 16px;
  font-weight: 700;
  line-height: 25px;
  letter-spacing: 0.5px;
  text-align: left;
  margin-bottom: 5px;
`;

export const GrayContainerTwo = styled.div`
  width: 100%;
  height: auto;
  padding: 20px;
  gap: 12px;
  border-radius: 8px;
  background: var(--gray-95, #f6f6f6);
`;

export const TriggerFrame = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: -10px;
`;

export const TriggerInsideFrame = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PeopleCountIsFrame = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const InsideTextsOfTrigger = styled.h3`
  font-family: Verizon NHG DS;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.5px;
  text-align: left;
`;

export const OperatorAndNumberFrame = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 10px;

  @media (max-width: 900px) {
    flex-wrap: wrap;
    max-width: 90vw;
  }
`;

export const ForFrame = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const GreyText = styled.div`
  font-family: Verizon NHG DS;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.5px;
  text-align: left;
  color: var(--vds-color-elements-secondary, #6f7171);
  margin-bottom: 10px;
`;
export const NotificationText = styled.div`
  font-family: Verizon NHG DS;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-align: left;
  color: var(--vds-color-elements-secondary, #6f7171);
  opacity: 0px;
`;

export const ConditionContainer = styled.div`
  width: Fill (682px) px;
  height: Hug (132px) px;
  padding: 0px 0px 0px 20px;
  gap: 20px;
  opacity: 0px;
`;

export const SmallText = styled.div`
  font-family: Verizon NHG DS;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
  text-align: left;
  margin-bottom: 5px;

  @media only screen and (max-width: 767px) {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const GreyTextField = styled.div`
  font-feature-settings: "clig" off, "liga" off;
  font-size: 12px;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: 0.5px;
  text-align: left;
  color: #6f7171;
  gap: 0px;
  opacity: 0px;
`;

export const AlertGroupFrame = styled.div`
  flex: 1;
  overflow-y: auto;
  margin-left: 1px;
  margin-top: -10px;
  scrollbar-width: thin !important;
  padding-right: 20px;
  margin-bottom: 10px;
`;

export const ModalBaseLayout = styled(BaseLayoutForRoiModal)`
  display: flex;
  flex-direction: column;
  height: inherit;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
`;

export const ModalHeadingFrame = styled(FrameForHeading)`
  margin: 0;
  padding: 0;
`;

export const ModalContentFrame = styled(ContentFrame)`
  overflow-y: auto;
  overflow-x: auto;
  height: inherit;
  gap: 0;
`;

export const InlineFlexRow = styled.div`
  display: inline-flex;
  gap: 5px;
  justify-content: space-between;
`;

export const SeverityActionRow = styled.div`
  display: inline-flex;
  justify-content: space-between;
  font-size: 12px;
`;

export const SpanWithPadding = styled.span`
  padding-left: 5px;
  padding-top: 5px;
`;

export const StickyButtonRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  position: sticky;
  bottom: 0;
`;

export const SpanWithLeftMargin = styled.span`
  margin-left: 30px;
`;
